import React from 'react';
import { MapIcon, KeyIcon, FilterIcon, AlertTriangleIcon, ShieldIcon, MessageSquareIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = [{
    title: 'El mapa secreto de mensajes que hace que él persiga',
    icon: MapIcon,
    image: 'https://cdn.magicpatterns.com/uploads/jSSM23oC6mygzJn1KBY2ex/ChatGPT_Image_21_mar_2026,_20_16_11.png'
  }, {
    title: 'Las llaves ocultas del deseo masculino',
    icon: KeyIcon,
    image: 'https://cdn.magicpatterns.com/uploads/sH6FH4ZszEt97RRFCHcBTR/ChatGPT_Image_21_mar_2026,_20_16_15.png'
  }, {
    title: 'El filtro invisible de hombres de alto valor',
    icon: FilterIcon,
    image: 'https://cdn.magicpatterns.com/uploads/osMXZCvj4BaWAHzRgu3dR5/ChatGPT_Image_21_mar_2026,_20_16_19.png'
  }, {
    title: 'Los errores silenciosos que lo alejan',
    icon: AlertTriangleIcon,
    image: 'https://cdn.magicpatterns.com/uploads/shUdcGMVK3gvqWPoMBnyuN/ChatGPT_Image_21_mar_2026,_20_17_36.png'
  }, {
    title: 'El sistema anti-rechazo (qué decir y cuándo)',
    icon: ShieldIcon,
    image: 'https://cdn.magicpatterns.com/uploads/6nfQyobFd6ZGhfvoQcvHGH/ChatGPT_Image_21_mar_2026,_20_24_29.png'
  }, {
    title: 'Mensajes reales decodificados',
    icon: MessageSquareIcon,
    image: 'https://cdn.magicpatterns.com/uploads/2shaxpyZR47Ue95UkorSVi/ChatGPT_Image_21_mar_2026,_20_24_39.png'
  }];
  return <section className="py-14 md:py-20 bg-dark relative overflow-hidden" data-id="element-17">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full bg-gold-900/10 blur-[120px] pointer-events-none" data-id="element-18"></div>

      {/* Scattered Particles */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-19">
        {[...Array(20)].map((_, i) => <div key={i} className="absolute rounded-full bg-gold-400/30 animate-pulse" style={{
        width: Math.random() * 4 + 1 + 'px',
        height: Math.random() * 4 + 1 + 'px',
        top: Math.random() * 100 + '%',
        left: Math.random() * 100 + '%',
        animationDelay: `${Math.random() * 3}s`,
        animationDuration: `${Math.random() * 2 + 2}s`
      }} data-id="element-20" />)}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-21">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-22">
          <div className="inline-flex items-center space-x-2 bg-gold-500/10 border border-gold-500/30 px-5 py-2 rounded-full mb-6 shadow-[0_0_15px_rgba(212,168,83,0.15)]" data-id="element-23">
            <SparklesIcon className="w-4 h-4 text-gold-400" data-id="element-24" />
            <span className="text-gold-400 font-bold text-sm uppercase tracking-wider" data-id="element-25">
              Incluido sin costo adicional
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white font-heading mb-6" data-id="element-26">
            Bonos Exclusivos{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-300 to-gold-600" data-id="element-27">
              Incluidos
            </span>
          </h2>

          <div className="w-24 h-1 bg-gradient-to-r from-gold-600 to-gold-400 mx-auto rounded-full mb-6 shadow-[0_0_10px_rgba(212,168,83,0.5)]" data-id="element-28"></div>

          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto font-medium" data-id="element-29">
            Todos estos bonos ya están incluidos dentro del costo, sin pago
            adicional.
          </p>
        </motion.div>

        {/* Bonus Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10" data-id="element-30">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} whileHover={{
            scale: 1.03
          }} className="group relative bg-gradient-to-b from-[#2A2A4A] to-[#1A1A2E] rounded-2xl border border-gold-500/20 hover:border-gold-500/50 shadow-lg hover:shadow-[0_0_40px_rgba(212,168,83,0.25)] transition-all duration-300 flex flex-col" data-id="element-31">
                {/* Image Area */}
                <div className="relative w-full aspect-[16/10] rounded-t-2xl overflow-hidden border-b border-white/5 bg-[#151525]" data-id="element-32">
                  {/* Bonus Image or Fallback */}
                  {bonus.image ? <img src={bonus.image} alt={bonus.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-33" /> : <>
                      <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_50%_50%,_#D4A853_0%,_transparent_70%)] group-hover:opacity-50 transition-opacity duration-500" data-id="element-34"></div>
                      <div className="absolute inset-0 opacity-20" style={{
                  backgroundImage: 'radial-gradient(rgba(255,255,255,0.2) 1px, transparent 1px)',
                  backgroundSize: '20px 20px'
                }} data-id="element-35"></div>
                    </>}

                  {/* Shimmer Sweep Effect on Hover */}
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out" data-id="element-36"></div>

                  {/* Decorative corner accents */}
                  <div className="absolute top-3 left-3 w-8 h-8 border-t border-l border-gold-500/30 rounded-tl-lg" data-id="element-37"></div>
                  <div className="absolute bottom-3 right-3 w-8 h-8 border-b border-r border-gold-500/30 rounded-br-lg" data-id="element-38"></div>
                </div>

                {/* Content Area */}
                <div className="relative pt-10 pb-8 px-6 flex-1 flex flex-col rounded-b-2xl" data-id="element-39">
                  {/* Overlapping Icon Badge */}
                  <div className="absolute -top-7 left-6 w-14 h-14 rounded-full bg-gradient-to-br from-gold-300 via-gold-500 to-gold-700 p-[2px] shadow-[0_0_20px_rgba(212,168,83,0.4)] z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-40">
                    <div className="w-full h-full bg-[#1A1A2E] rounded-full flex items-center justify-center" data-id="element-41">
                      <Icon className="w-6 h-6 text-gold-400 group-hover:text-gold-300 transition-colors" data-id="element-42" />
                    </div>
                  </div>

                  <h3 className="text-xl md:text-2xl font-bold text-white font-heading leading-snug group-hover:text-gold-300 transition-colors mt-2" data-id="element-43">
                    {bonus.title}
                  </h3>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Footer Reinforcement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-16 text-center" data-id="element-44">
          <p className="text-xl md:text-2xl text-gold-400 font-medium font-heading italic" data-id="element-45">
            "Accede a todo este contenido exclusivo desde el primer momento."
          </p>
        </motion.div>
      </div>
    </section>;
}